import { Component, ElementRef, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { GlobalFunctions, SnackType } from '@global/GlobalFunctions';
import { siteSubscriptions } from '@services/siteSubscriptions';
import { IOrganisationsHierarchy, OrganisationDataModelNode, OrganisationDataService, OrganisationsHierarchy } from '@services/organisation-data.service';
import {
	ContextMenuComponent, DragAndDropEventArgs, MenuEventArgs, MenuItemModel, NodeClickEventArgs,
	NodeExpandEventArgs, NodeSelectEventArgs, TreeViewComponent
} from '@syncfusion/ej2-angular-navigations';
import { BehaviorSubject, combineLatest, distinctUntilChanged, filter, finalize, Observable, Subject, takeUntil } from 'rxjs';
import { AssetsDataService, LevelAsset } from '@services/assets-data.service';
import { AuthenticationService, IWebAppUser } from '@services/authentication.service';
import { Account, IAccount } from '@services/accounts.service';
import { Rule, RulesDataService } from '@services/rules-data.service';
import { Location } from '@angular/common';
import { TreeDashboardDrag } from '../organisation-data-model/organisation-data-model.component';

/**
 * Component
 */
@Component({
	selector: 'app-heirarchy-management',
	templateUrl: './heirarchy-management.component.html',
	styleUrls: ['./heirarchy-management.component.scss', 'icons.component.css']
})
export class HeirarchyManagementComponent implements OnInit, OnDestroy {

	/** Show the Spinner */
	public showSpinner: boolean = false

	/** hierarchical Data */
	private hierarchicalData$: Observable<string>;
	/** hierarchical Data Subject*/
	private hierarchicalDataSubject: BehaviorSubject<string>;

	/** hierarchicalData */
	public hierarchicalData: OrganisationsHierarchy[];
	/** treeData */
	public treeData: OrganisationsHierarchy[];
	/** ShowHiddenLocations */
	public ShowHiddenLocations: number = 1;
	/** nodeState */
	private nodeState: any = []
	/** field */
	public fields: Object

	/** Observable Subject Finalise */
	private finalise = new Subject<void>();

	/** locationID */
	public locationID: string;
	/** locationType */
	public locationType: string = "location"
	/** selectedNode */
	public selectedNode: any;

	/** Allow multi selection */
	public allowMultiSelection: boolean = true;
	/** Allow drag and drop */
	public allowDragAndDrop: boolean = true;

	/** accountID */
	public accountID: string;
	/** selectedAccount */
	public selectedAccount: IAccount;
	/** OrganisationID */
	public OrganisationID: string;

	/** this user */
	public thisUser: IWebAppUser;

	/** menuItems */
	public menuItems: MenuItemModel[] = [
		{
			text: 'Add Asset',
			// iconCss: 'e-cm-icons e-cut'
		},
		{
			text: 'Copy Asset',
			// iconCss: 'e-cm-icons e-copy'
		},
		{
			separator: true
		},
		{
			text: 'Delete Asset',
			// iconCss: 'e-cm-icons e-copy'
		}

	]

	/** isLoading */
	public isLoading = true; //for tree spinner

	/** contextMenu */
	@ViewChild('contextmenu') public contextMenu: ContextMenuComponent;

	/** treeView */
	@ViewChild('treeView', { static: true }) public treeView: TreeViewComponent;

	/** treeContainer */
	@ViewChild('treeContainer', { static: false }) public treeContainer: ElementRef;

	/** content */
	public content: string = 'click me';
	/** savedScrollPosition */
	private savedScrollPosition: number = 0;
	/** checkedAssetIDs */
	public checkedAssetIDs: number[] = [];
	/** assetIDsWithActiveRules */
	public assetIDsWithActiveRules: number[] = [];
	/** assets */
	public assets: LevelAsset[];

	/** selectedLocationUID */
	public selectedLocationUID: string;

	/** onDashboardCreationPage */
	@Input() onDashboardCreationPage: boolean = false;

	/** flattenedSubLocations */
	public flattenedSubLocations: OrganisationsHierarchy[];

	/** dragComplete */
	@Output() dragComplete = new EventEmitter<TreeDashboardDrag>();

	/**
	 *
	 * @param siteSubscriptions  siteSubscriptions
	 * @param globalFunctions globalFunctions
	 * @param router router
	 * @param route route
	 * @param assetsDataService assetsDataService
	 * @param organisationDataService organisationDataService
	 * @param authenticationService authenticationService
	 */
	constructor(private siteSubscriptions: siteSubscriptions,
		private globalFunctions: GlobalFunctions,
		private router: Router,
		private route: ActivatedRoute,
		private location: Location,
		private assetsDataService: AssetsDataService,
		private organisationDataService: OrganisationDataService,
		private authenticationService: AuthenticationService,
		private rulesDataService: RulesDataService) {

		this.hierarchicalDataSubject = new BehaviorSubject<string>("");
		this.hierarchicalData$ = this.hierarchicalDataSubject.asObservable();

		this.nodeState = [];
		let HeirarchyExpandedNodes = localStorage.getItem("HeirarchyExpandedNodes")
		if (HeirarchyExpandedNodes) { this.nodeState = JSON.parse(HeirarchyExpandedNodes) }

		combineLatest([
			this.authenticationService.currentUser$.pipe(takeUntil(this.finalise), distinctUntilChanged()),
			this.siteSubscriptions.selectedAccountGUID$.pipe(takeUntil(this.finalise), distinctUntilChanged()),
			this.siteSubscriptions.selectedAccount$.pipe(takeUntil(this.finalise), distinctUntilChanged()),
			this.siteSubscriptions.selectedOrganisationUID$.pipe(takeUntil(this.finalise), distinctUntilChanged()),
			this.route.paramMap.pipe(takeUntil(this.finalise), distinctUntilChanged()),
			this.route.queryParamMap.pipe(takeUntil(this.finalise), distinctUntilChanged())
		]).pipe(
			// Ensure that subscriptions are not null or undefined
			filter(([currentUser, selectedAccountGUID, account, selectedOrganisationUID, paramMap, queryParamMap]) =>
				!!currentUser && !!selectedAccountGUID && !!account && !!selectedOrganisationUID && !!paramMap && !!queryParamMap)
		).subscribe({
			next: ([currentUser, selectedAccountGUID, account, selectedOrganisationUID, paramMap, queryParamMap]) => {

				this.thisUser = <IWebAppUser>currentUser

				if (this.accountID != selectedAccountGUID || this.OrganisationID != selectedOrganisationUID) {

					this.selectedAccount = account;
					this.selectedAccount = this.siteSubscriptions.normalizeFeatures(this.selectedAccount) as Account;
					this.accountID = selectedAccountGUID;
					if (!this.selectedAccount.Admin) {
						alert("Invalid Access to this Page");
						router.navigate(["."])
					}
					
					this.OrganisationID = selectedOrganisationUID;
					var organisation = paramMap.get('organisation') ?? "";
					//this.getAllAssets()
					this.subscribeOrganisationStructure(this.accountID, this.OrganisationID, this.ShowHiddenLocations);
				}
				this.locationID = queryParamMap.get('locationID') ?? queryParamMap.get('assetID') ?? "";
				if (!this.isParsableAsNumber(this.locationID)) {
					this.locationType = 'location'
				} else { this.locationType = 'asset' }
				this.selectedLocationUID = queryParamMap.get("selectedLocation") ?? "";
				if (this.selectedLocationUID) {
					this.findSelectedLocation(this.selectedLocationUID);
				}
			},
			error: (error) => {
				this.globalFunctions.HandleError(error, "Error: Error in one of the combined subscriptions", false);
			}
		});

		/** Subscribe tp the Tree Structure */
		this.subscribeHierarchicalData()

	}

	/**
	 * getAllAssets
	 */
	getAllAssets() {
		const fetchDataSubject = new Subject<void>();
		this.assetsDataService.getOrganisationAssets$(this.accountID, this.OrganisationID).pipe(
			takeUntil(fetchDataSubject), distinctUntilChanged(),
			filter((ruleEvents) => !!ruleEvents),
			finalize(() => {
				// Ensure the subscription is terminated and the subject is completed
				fetchDataSubject.next();
				fetchDataSubject.complete();
			})
		).subscribe({
			next: (assets: any) => {
				this.assets = assets;
				this.checkActiveRules();
			},
			error: (error) => { if (error.status == 404) { }
				else { this.globalFunctions.HandleError(error, "Error: AssetsDataService.getOrganisationAssets$", false); }
			},
		});

	}

	/**
	 * checkActiveRules
	 */
	checkActiveRules() {
		for (let i = 0; i < this.assets.length; i++) {
			const fetchDataSubject = new Subject<void>();

			let result: boolean = false;

			let assetRules: Rule[] = [];
			this.rulesDataService.getRules$(this.accountID, this.OrganisationID, this.assets[i].AssetID).pipe(
				takeUntil(fetchDataSubject), distinctUntilChanged(),
				filter((ruleEvents) => !!ruleEvents),
				finalize(() => {
					// Ensure the subscription is terminated and the subject is completed
					fetchDataSubject.next();
					fetchDataSubject.complete();
				})
			).subscribe({
				next: (rules: any) => {
					assetRules = rules;
					if (assetRules) {
						for (let i = 0; i < assetRules.length; i++) {
							if (assetRules[i].Active) { result = true }
						}
						if (result) { this.assetIDsWithActiveRules.push(this.assets[i].AssetID) }
					}
				},
				error: (error) => { console.log(error); },
			});
		}
	}

	/**
	 * Page On Destroy Event Handler
	 */
	ngOnDestroy(): void {
		try {
			// Unsubscribe from all subscriptions
			this.finalise.next();
			this.finalise.complete();
		}
		catch { }
	}

	/**
	 * Update the tree if one of the children edits something
	 * @param event
	 */
	handleDataChanged(event: boolean) {

		if (this.treeContainer) {
			this.savedScrollPosition = this.treeContainer.nativeElement.scrollTop;
		}

		this.subscribeOrganisationStructure(this.accountID, this.OrganisationID, this.ShowHiddenLocations);

		if (this.treeContainer) {
			setTimeout(() => {
				this.treeContainer.nativeElement.scrollTop = this.savedScrollPosition;
			}, 100);
		}
	}

	/**
	 * getHierarchicalData
	 * @param paramAsset
	 */
	public subscribeHierarchicalData() {
		this.hierarchicalData$.pipe(
			takeUntil(this.finalise), distinctUntilChanged(),
			filter((data) => !!data)
		).subscribe({
			next: (data: string) => {
				if (data != "") {
					this.hierarchicalData = <OrganisationsHierarchy[]>JSON.parse(data);
					this.treeData = <OrganisationsHierarchy[]>JSON.parse(data);
					this.updateTree();
				}
			},
			error: (error) => { this.globalFunctions.HandleError(error, "Error: this.siteSubscriptions.hierarchicalData$", false) },
			//complete: () => {console.log("this.siteSubscriptions.hierarchicalData$.subscribe: Complete");}
		});
	}


	/**
	 * Update Tree
	 */
	updateTree() {
		this.treeData = this.addListItemsAsChildren(this.treeData);
		this.treeData = this.resetExpanded(this.treeData);

		this.flattenedSubLocations = this.flattenSubLocations(this.treeData, true);
		// this.treeData[0].Expanded = true;

		this.fields = {
			dataSource: this.treeData,
			id: 'Uid',
			text: 'concatenatedText',
			child: 'SubChild',
			// iconCss: 'LocationType',
			// imageUrl: 'ImageURL',
			expanded: 'Expanded',
			hidden: 'Hidden',
			parentUID: 'ParentUid'
		};
	}


	/**
	 * Set the expanded state of the nodes according to the stored data
	 * @param data
	 * @returns
	 */
	resetExpanded(data: OrganisationsHierarchy[]): OrganisationsHierarchy[] {

		/**
		 * Internal Function
		 * @param data
		 */
		const transformListItems = (data: any[]) => {
			for (let i = 0; i < data.length; i++) {
				try {
					// if(data[i].LocationType){
					// 	data[i].LocationType = 'header'
					// }
					let node = this.nodeState.find((x: { node: string; }) => x.node.toString().toUpperCase() === data[i].Uid.toString().toUpperCase())
					if (node) {
						if (!data[i].SubChild && !data[i].Assets) {
							data[i].Expanded = false
						} else {
							data[i].Expanded = node["expanded"]
						}
					} else {
						data[i].Expanded = false
					}
					if (data[i].SubChild) {
						transformListItems(data[i].SubChild);
					}
				} catch (error) {
					console.error(error);
				}

			}
		};

		transformListItems(data);

		return data;
	}

	/**
	 * Remember the expanded state of the Nodes in the tree
	 * @param args
	 */
	nodeExpanded(args: NodeExpandEventArgs) {

		if (this.treeContainer) {
			this.savedScrollPosition = this.treeContainer.nativeElement.scrollTop;
		}

		let node = this.nodeState.find((x: { node: string; }) => x.node == args.nodeData["id"]);
		if (node) {
			node["expanded"] = args.nodeData["expanded"];
		} else {
			this.nodeState.push({ "node": args.nodeData["id"], "expanded": args.nodeData["expanded"] });
		}

		localStorage.setItem("HeirarchyExpandedNodes", JSON.stringify(this.nodeState));
		this.updateTree();
		this.subscribeHierarchicalData();

		if (this.treeContainer) {
			setTimeout(() => { this.treeContainer.nativeElement.scrollTop = this.savedScrollPosition; }, 1);
		}

	}

	/**
	 * addListItemsAsChildren
	 * @param data
	 * @returns
	 */
	addListItemsAsChildren(data: OrganisationsHierarchy[]): OrganisationsHierarchy[] {

		/**
		 * Internal Function
		 * @param data
		 */
		const transformListItems = (data: any[]) => {
			for (let i = 0; i < data.length; i++) {

				if (data[i].concatenatedText == undefined) {
					let _Name = data[i].Name;
					let _FunctionalLocation = data[i].FunctionalLocation;
					if (!!_FunctionalLocation) { _Name = `${_Name} (${_FunctionalLocation})`; }
					data[i].concatenatedText = _Name;
				}

				if (data[i].Assets) {
					data[i].SubChild = data[i].SubChild || [];
					data[i].Assets.forEach((item: any) => {
						if (!item.Deleted) {
							let _Name = item["Name"];
							let _Description = item["Description"];
							if (_Name != _Description && !!_Description) { _Name = `${_Name} - ${_Description}`; }
							item["concatenatedText"] = _Name;
							item["Uid"] = <string>item["AssetID"];
							item["LocationType"] = 'e-icons e-folder';
							data[i].SubChild.push(item);
						}
					});
					data[i].Assets = []; // Clear items after moving them to SubChild
				}
				if (data[i].SubChild) {
					transformListItems(data[i].SubChild);
				}
			}
		};

		transformListItems(data);

		return data;
	}

	/**
	 * Page On Initialise Event Handler
	 */
	ngOnInit(): void {
		this.changeAccordionHeaderColor("orange")
	}

	/**
	 * show
	 */
	show() {
		this.isLoading = true; // Show the spinner
		this.globalFunctions.displaySpinner(true)
	}

	/**
	 * hide
	 */
	hide() {
		this.isLoading = false; // Hide the spinner after data is loaded
		this.globalFunctions.displaySpinner(false)
	}

	/**
	 * changeAccordionHeaderColor
	 * @param color
	 */
	changeAccordionHeaderColor(color: string) {
		const elements = document.querySelectorAll('.e-accordion .e-acrdn-item.e-select > .e-acrdn-header');
		elements.forEach((element) => {
			(element as HTMLElement).style.background = color;
		});
	}

	/**
	 * Node Selected
	 * @param event
	 */
	public nodeSelected(event: NodeSelectEventArgs) {

		// let data = this.hierarchicalData.find((x: { Id: any; }) => x.Id == event.nodeData.id)
		let queryParams = {}

		if (!this.isParsableAsNumber(event.nodeData['id'])) {
			queryParams = {
				locationID: event.nodeData['id'],
				assetID: undefined
			};

		} else {
			queryParams = {
				locationID: undefined,
				assetID: event.nodeData['id']
			};

		}

		// console.log(event);
		// Update the route with the new query parameters
		this.router.navigate([], {
			relativeTo: this.route,
			queryParams: queryParams,
			queryParamsHandling: 'merge' // merge with existing query parameters
		});
	}

	/**
	 * Check if string can be parsed as int
	 * @param str
	 * @returns
	 */
	isParsableAsNumber(str: any): boolean {
		const parsed = Number(str);
		return !isNaN(parsed);
	}

	public onDragStart(event: DragAndDropEventArgs) {
		const draggedNodeData = event.draggedNodeData;
		let text: any = draggedNodeData["text"];
		const textParts = text.split(' ', 2);
		if (textParts.length > 1) {
			text = text.substring(text.indexOf(' ') + 1);
		}
		draggedNodeData["text"] = text;
	}

	/**
	 * onDragStop
	 * @param args
	 */
	public onDragStop(args: DragAndDropEventArgs): void {
		// Create a local Subject to control the subscription lifecycle
		const fetchDataSubject = new Subject<void>();
		if (this.isParsableAsNumber(args.droppedNodeData["id"])) {
			args.cancel = true
		}
		if (args.draggedNodeData["id"] != args.droppedNodeData["id"] && args.droppedNodeData["id"] != args.draggedNodeData["parentID"]) { // if something actually moved
			const droppedNodeData = args.droppedNodeData;
			let text: any = droppedNodeData["text"];
			const textParts = text.split(' ', 2);
			if (textParts.length > 1) {
				text = text.substring(text.indexOf(' ') + 1);
			}
			droppedNodeData["text"] = text;
			if (!this.isParsableAsNumber(args.droppedNodeData["id"])) { // if we are trying to move to a location and not asset
				if (confirm("Move " + args.draggedNodeData["text"] + " to " + args.droppedNodeData["text"] + "?")) {
					if (this.isParsableAsNumber(args.draggedNodeData["id"])) { // if we dragged an asset (change to use location type)
						let asset: any = this.organisationDataService.findObjectByUID(args.draggedNodeData["id"].toString(), this.treeData);
						this.assetsDataService.moveOrganisationAssets$(this.accountID, this.OrganisationID, asset.AssetID, args.droppedNodeData["id"].toString()).pipe(
							takeUntil(fetchDataSubject), distinctUntilChanged(),
							filter((response) => !!response),
							finalize(() => {
								// Ensure the subscription is terminated and the subject is completed
								fetchDataSubject.next();
								fetchDataSubject.complete();
							})
						).subscribe({
							next: (response) => {
								try {
									// console.log("Done")
									this.subscribeOrganisationStructure(this.accountID, this.OrganisationID, this.ShowHiddenLocations);
									this.globalFunctions.DisplaySnackBar({
										message: "Hierarchy Details Updated",
										type: SnackType.Info,
										duration: 1000
									});
								} catch (error) {
									this.globalFunctions.HandleError(error, "")
								}
							},
							error: (error) => {
								console.error(error)
								this.globalFunctions.HandleError(error, "updateSystemsGroups: Error updating system group info")
							},
							complete: () => { }
						});
					} else { //if we dragged a location
						let Mylocation: OrganisationsHierarchy = this.organisationDataService.findObjectByUID(args.draggedNodeData["id"].toString(), this.treeData);
						Mylocation.ParentUid = args.droppedNodeData["id"].toString(); //changing parent location to where it was dropped
						this.organisationDataService.patchOrganisationLocation$(this.accountID, this.OrganisationID, Mylocation).pipe(
							takeUntil(fetchDataSubject), distinctUntilChanged(),
							filter((response) => !!response),
							finalize(() => {
								// Ensure the subscription is terminated and the subject is completed
								fetchDataSubject.next();
								fetchDataSubject.complete();
							})
						).subscribe({
							next: (response) => {
								this.subscribeOrganisationStructure(this.accountID, this.OrganisationID, this.ShowHiddenLocations)
								this.globalFunctions.DisplaySnackBar({
									message: "Hierarchy Details Updated",
									type: SnackType.Info,
									duration: 1000
								});
							}
						});
					}
				}
				else {
					args.cancel = true;
				}
			}
		}
	}

	/**
	 * Event triggers once the context menu rendering is completed.
	 */
	onCreated(): void {
		this.content = this.contextMenu.animationSettings.effect = 'SlideDown';
	}

	/**
	 * addDisabled
	 * @param args
	 */
	public addDisabled(args: MenuEventArgs) {
		if (args.item.text === 'Link') {
			args.element.classList.add('e-disabled');
		}
	}

	/**
	 * onNodeClicked
	 * @param args
	 */
	public onNodeClicked(args: NodeClickEventArgs): void {
		if (args.event.button == 2) {
			if (this.contextMenu) { this.contextMenu.open(args.event.clientY, args.event.clientX); }
		}
	}

	/**
	 * Open the custom context menu on right-click
	 * @param args
	 * @param node
	 */
	public onNodeRightClick(args: MouseEvent, node: any): void {
		args.preventDefault();
		// this.treeView.selectedNodes = [node.getAttribute('data-uid')]; // Select the right-clicked node
		if (this.contextMenu) { this.contextMenu.open(args.pageY, args.pageX); }
	}

	/**
	* Get the Organisation Structure
	* @param AccountID AccountID
	* @param OrganisationUID OrganisationUID
	* @param ShowHidden ShowHidden
	*/
	subscribeOrganisationStructure(AccountID: string, OrganisationUID: string, ShowHidden: number = 0) {
		// Create a local Subject to control the subscription lifecycle
		const fetchDataSubject = new Subject<void>();

		try {
			/** Get the Organisation for the selection */
			this.organisationDataService.getOrganisationStructure$(AccountID, OrganisationUID, ShowHidden).pipe(
				takeUntil(fetchDataSubject), distinctUntilChanged(),
				filter((structure) => !!structure),
				finalize(() => {
					// Ensure the subscription is terminated and the subject is completed
					fetchDataSubject.next();
					fetchDataSubject.complete();
				})
			).subscribe({
				next: (structure: any) => {
					try {
						/** Update the Organisation */
						var OrganisationStructure = <OrganisationsHierarchy[]>JSON.parse(structure);
						this.hierarchicalDataSubject.next(JSON.stringify(OrganisationStructure));
					} catch (error) { console.error(error); }
				},
				error: (error) => {
					if (error["status"] != 404) {
						this.globalFunctions.HandleError(error, "Error: OrganisationData.getOrganisationStructure$(OrganisationUID).subscribe$", false)
					}
				},
				//complete: () => { console.log("OrganisationData.getOrganisationStructure$(OrganisationUID).subscribe: Complete"); }
			});
		} catch (error) { console.error(error); }
	}

	/**
	 * findSelectedLocation
	 * @param locationUID locationUID 
	 */
	findSelectedLocation(locationUID: string) {
		if (this.hierarchicalData) {
			let list = this.flattenSubLocations(this.hierarchicalData);
			let sublocation = list.find((x) => x.Uid == locationUID);
			if (sublocation) {
				this.expandParents(sublocation, list);
			}
			this.router.navigate([this.router.url.split("?")[0]], {});
		}
		else {
			setTimeout(() => {
				this.findSelectedLocation(locationUID);
			}, 1);
		}
	}

	/**
	 * flattenSubLocations
	 * @param hierarchy hierarchy 
	 * @returns 
	 */
	flattenSubLocations(hierarchy: OrganisationsHierarchy[], includeTopLevel: boolean = false): any[] {
		let result: any[] = [];

		// Check if hierarchy is a valid array before proceeding
		if (!Array.isArray(hierarchy)) {
			return result;
		}

		if (includeTopLevel) {
			result.push(...hierarchy);
		}

		// Iterate over each item in the input hierarchy
		for (const item of hierarchy) {
			// Check if the item has a non-empty 'Asset' property
			if (item.SubChild && item.SubChild.length > 0) {
				result = result.concat(item.SubChild);
			}

			// Recursively add all 'Asset' properties of the item's subchildren
			result = result.concat(this.flattenSubLocations(item.SubChild));
		}

		return result;
	}

	/**
	 * expandParents
	 * @param location location  
	 * @param hierarchy hierarchy 
	 */
	expandParents(location: IOrganisationsHierarchy, list: IOrganisationsHierarchy[]) {
		let loop: boolean = true;
		let checkingLocation = location;
		while (loop) {
			let node = this.nodeState.find((x: { node: string; }) => x.node == checkingLocation.Uid);
			if (node) {
				node["expanded"] = true;
			} else {
				this.nodeState.push({ "node": checkingLocation.Uid, "expanded": true });
			}
			if (checkingLocation.ParentUid) {
				let temp = list.find((x: IOrganisationsHierarchy) => x.Uid == checkingLocation.ParentUid);
				if (temp) {
					checkingLocation = temp;
				} else {
					checkingLocation = this.hierarchicalData[0];
				}
			} else {
				loop = false;
				break;
			}
		}
		localStorage.setItem("HeirarchyExpandedNodes", JSON.stringify(this.nodeState));
		this.updateTree();
		this.subscribeHierarchicalData();
	}

	/**
	 * onDragStop -- dragging onto a dashboard
	 * @param event event  
	 */
	dragIntoDashboard(event: DragAndDropEventArgs) {
		let elements: any[] = [];
		let target: HTMLElement | null = event.target;
		while (target) {
			elements.push(target);
			target = target.parentElement;
		}
		let targetElement: HTMLElement = elements.find((x: HTMLElement) => x.classList.contains("panel-host"));
		const draggedNode: OrganisationsHierarchy | undefined = this.flattenedSubLocations.find((x: OrganisationsHierarchy) => x.Uid == event.draggedNodeData["id"]);
		if (targetElement && draggedNode) {
			this.dragComplete.emit({
				htmlElement: targetElement,
				panelID: targetElement.id,
				draggedNode: draggedNode
			});
		}
	}
}
